import { action } from 'typesafe-actions';

import { IIntegration, IntegrationTypes } from './types';

export const loadRequest = () => action(IntegrationTypes.LOAD_REQUEST);
export const loadSuccess = (data: IIntegration[]) => action(IntegrationTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(IntegrationTypes.LOAD_FAILURE);
